export const getRetrieveVehicleKey = () => [`drivers_vehicle`];
